import React from 'react';
import { CompanyResource } from '../../common/entities';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { isArray } from 'lodash';
import { Link } from 'react-router-dom';

/**
 * @description Properties to be passed to this component.
 * @interface
 */
interface Props {
  company: CompanyResource;
}

/**
 * @description Company List component, high level information about companies services.
 * @param {Props} props
 * @return {JSX.Element}
 */
const CompanySearchResult = (props: Props): JSX.Element => {
  const company = props.company.attributes;
  return (
    <article>
      <Row>
        <Col xs={12} className="d-flex justify-content-between">
          <div className="d-flex justify-content-between">
            <img
              width="64"
              height="64"
              style={{
                maxWidth: '64px',
                maxHeight: '64px',
                marginRight: '1rem',
              }}
              className="img-thumbnail"
              src={company.logoUrlCdn}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = '/assets/img/email-newsletter-1px.png';
              }}
              alt={company.companyNameText ?? company.companyName}
            />
            <div>
              <h2 className="mb-n1">
                {company.companyNameText ?? company.companyName}
              </h2>
              <p>
                {company.primaryTag} |
                {company.headquarters &&
                company.headquarters !== company.ecosystemName
                  ? ` ${company.headquarters} |`
                  : ''}{' '}
                {company.ecosystemName}
              </p>
            </div>
          </div>

          <div>
            <Button href={company.website} target="_blank" rel="briefed.in">
              Website{' '}
              <span className="material-icons-outlined text-sm align-middle">
                launch
              </span>
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <p>{company.description} &nbsp;</p>
          <p>
            {isArray(company.tags) ? (
              <span>
                {company.tags.map((tag) => (
                  <Link
                    key={tag}
                    to={{
                      search: `?q=&a=tags|${tag}&p=1`,
                    }}
                  >
                    <Badge bg={'light'} style={{ marginRight: '1rem' }}>
                      {tag}
                    </Badge>
                  </Link>
                ))}
              </span>
            ) : null}
            <span className="">
              <a
                href={`/company.html?${company.id}`}
                className="text-primary text-sm"
              >
                More info&nbsp;
                <span className="material-icons-outlined text-sm text-primary align-middle">
                  arrow_circle_right
                </span>
              </a>
            </span>
          </p>
        </Col>
      </Row>
      <hr />
    </article>
  );
};

export default CompanySearchResult;
